
import React, { useEffect, useRef, useState } from 'react';
import Head from 'next/head';

import slugify from 'react-slugify';
import { event } from '../../../../../../lib/gtag';
import { callDealershipEvent } from '../../../../../../utils/Analytics';
import handleTimeout from '../../../../../../helper/timeout_handler';
import renderVehicleTitle from '../../../../../../helper/vehicle_title_render';
import { userRequestOptions, userRequestOptionsForBOI } from '../../../../../../helper/constants';
import { useRouter } from 'next/router';

import Footer from '../../../../../../components/Footer';
import Header from '../../../../../../components/Header';
import OptionPreview from '../../../../../../components/OptionPreview';
import RadioButtonsGroup from '../../../../../../components/RadioButtonsGroup';
import PreferredDealership from '../../../../../../components/PreferredDealership';
import DealerPhone from '../../../../../../components/DealerPhone';
import VehicleEnquiryForm from '../../../../../../components/Form/VehicleEnquiry';
import Backend from '../../../../../../utils/Backend';
import Thanks from '../../../../../../components/Thanks';
import Loader from '../../../../../../components/Loader';

import IGenericOption from '../../../../../../interfaces/IGenericOption';

import styles from './styles.module.scss';

import { useIsBoiWebsite } from "../../../../../../components/Context/WebsiteType";

// option gets here from the special requests far below (NEXT.JS APPROACH)
export default function OptionPage({ option }: any) {
  const [imageURL, setImageURL] = useState("")
  const [userRequest, setUserRequest] = useState<IGenericOption>();
  const [dealership, setDealership] = useState<any>();
  const [submitted, setSubmitted] = useState(false);

  const dealershipsRef = useRef<HTMLHRElement>(null);
  const formRef = useRef<HTMLHRElement>(null);

  const [customDealership, setCustomDealership] = useState<string>();

  const router = useRouter()

  const isBoiWebsite = useIsBoiWebsite();

  useEffect(() => {
    if (option) {
      setImageURL(Backend.getImage(option, "28"))
    }
  }, [option])

  useEffect(() => {
    if (!!userRequest) {
      if (!!customDealership) {
        formRef.current?.scrollIntoView({ behavior: "smooth" });
      }
      else {
        dealershipsRef.current?.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [userRequest, customDealership])
  
  useEffect(() => {
    if (!!!customDealership) {
      if (!!dealership) {
        setTimeout(() => {
          formRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 50)
      }
    }
  }, [dealership, customDealership])

  // tracking 'Call dealership' click event
  useEffect(() => {
    if (option && (userRequest?.value === "CALL_DEALERSHIP" || userRequest?.value === "CALL_DEALERSHIP_BOI") && !!dealership?.phone) {
      event("vehicleEnquiryCallDealership");
      callDealershipEvent(isBoiWebsite, option.id, dealership.id);
    }
  }, [userRequest, dealership, option, isBoiWebsite])


  const goBack = () => {
    setUserRequest(isBoiWebsite ? userRequestOptionsForBOI[0] : userRequestOptions[0])
    setSubmitted(false)
  }

  const onSelect = (selected: IGenericOption | undefined, setSelected: any) => {
    setSelected(selected);
  }

  const submitCallback = () => {
    if (!userRequest) {
      setSubmitted(true);
      window.scrollTo(0, 0);
      return;
    }

    const enquiry_type = option.vehicle_type === 'commercial' ? 'commercial' : 'private';
    const action = slugify(userRequest.value)
    
    const { make, model, id } = router.query

    router.push(`/thankyou/${enquiry_type}/${action}/${make}/${model}/${id}`)
  }

  const renderForm = () => {
    if (!userRequest) return <p>Please complete the previous steps to continue with your enquiry.</p>
    
    if (!option || !dealership) {
      return (
        <p>Please, select dealership</p>
      )
    }

    console.log("Options Page", userRequest.value)

    // returns Call A Dealership
    if (userRequest.value === "CALL_DEALERSHIP" || userRequest.value === "CALL_DEALERSHIP_BOI") {
      console.log("CALL_DEALERSHIP")
      return (
        <DealerPhone 
          name={dealership.label}
          phone={dealership.phone}
          notProvidedName={dealership.dealershipText}
        />
      )
    }

    return (
      <div className={`${isBoiWebsite ? `${styles.formHolderBoi} ${styles.userRequestHolderBoi}` : `${styles.formHolder} ${styles.userRequestHolder}`}`}>
        <VehicleEnquiryForm
          header={userRequest.label}
          text='Leave your details and dealership will fulfil your request'
          submittedText=''
          vehicle_id={option.id}
          dealership_id={dealership.id}
          action={userRequest.value}
          callback={submitCallback}
          customDealership={customDealership}
        />
      </div>
    )
  }


  return (
    <>
      <Head>
        <title>{ renderVehicleTitle(option) } | Nevo</title>
      </Head>

      {isBoiWebsite ? <Header transparent /> : <Header />}
      
      <div className={`${isBoiWebsite ? styles.vehicleContactPageBoi : styles.vehicleContactPage} page-holder`}>
        {option ? 
          <div className={`${isBoiWebsite ? styles.vehicleContactHolderBoi : styles.vehicleContactHolder} post-holder`}>
            <OptionPreview 
              make={option.make} 
              model={option.model} 
              trim_level={option.trim_level}
              image={imageURL}
              isBoiWebsite={isBoiWebsite}
            />

            { (submitted && dealership) ? 
              <div className={`${isBoiWebsite ? styles.thanksHolderBoi : styles.thanksHolder}`}>
                <Thanks 
                  make={option.make}
                  model={option.model}
                  dealership={dealership.name}
                  goBack={goBack}
                />
              </div> 
              : 
              <>
                <div className={`${isBoiWebsite ? styles.userRequestHolderBoi : styles.userRequestHolder} ${styles.wantToHolder}`}>
                  <h1 className={`${isBoiWebsite ? styles.stepTextBoi : styles.stepText}`}>Step 1</h1>
                  <p className={`${isBoiWebsite ? styles.vehicleContactHeaderBoi : styles.vehicleContactHeader}`}>I want to:</p>
                  <div className={`${isBoiWebsite ? styles.userRequestOptionsBoi : styles.userRequestOptions}`}>
                    <RadioButtonsGroup
                      selected={userRequest} 
                      options={isBoiWebsite ? userRequestOptionsForBOI : userRequestOptions}
                      setSelected={selected => { onSelect(selected, setUserRequest) }}
                    />
                  </div>
                </div>
                
                <hr ref={dealershipsRef} />

                <div className={`${isBoiWebsite ? styles.userRequestHolderBoi : styles.userRequestHolder}`}>
                  <h1 className={`${isBoiWebsite ? styles.stepTextBoi : styles.stepText}`}>Step 2</h1>
                  <p className={`${isBoiWebsite ? styles.vehicleContactHeaderBoi : styles.vehicleContactHeader}`}>Preferred Dealership:</p>
                  
                  <div className={`${isBoiWebsite ? styles.userRequestBoi : styles.userRequest}`}>
                    <PreferredDealership 
                      dealership={dealership}
                      setDealership={dealership => setDealership(dealership)}
                      makeId={option.global_data.manufacturer}
                      vehicle_type={option.vehicle_type}
                      disabled={!userRequest}
                      customDealership={customDealership}
                      setCustomDealership={setCustomDealership}
                    />
                  </div>
                </div>

                <hr ref={formRef}/>

                <h1 className={`${isBoiWebsite ? styles.stepTextBoi : styles.stepText}`}>Step 3</h1>
                { renderForm() }
              </>
            }
          </div>
          : <Loader className={`${isBoiWebsite ? styles.optionLoaderBoi : styles.optionLoader}`} />
        }
      </div>

      <Footer />
    </>
  );
};

// pre-build features
// export async function getStaticPaths() {
//   const response = await Backend.getAllVehicles()

//   const vehicles = response.data.content.vehicles

//   // Get the paths we want to pre-render based on vehicles
//   const paths = vehicles.map((vehicle: any) => ({
//     params: { 
//       make: slugify(vehicle.make),
//       model: slugify(vehicle.model),
//       id: `${vehicle.third_party.variantId}`
//     },
//   }))

//   // { fallback: false } means other routes should 404.
//   return { 
//     paths,
//     fallback: true
//   }
// }

export async function getServerSideProps({ res, params: { id } } : any) {
  // params contains the vehicle `id`
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  )

  const response = await handleTimeout(Backend.getVariant(id), `Variant ${id}`)
  
  if (!response) {
    throw new Error("Failed to fetch Option")
  }

  const option = response.data.content

  // Pass data to the page via props
  return { 
    props: { option }
  }
}
